export default __webpack_public_path__ + "static/media/covid1.aa223103.jpg";